<span [ngClass]="{'text-dark': isActive ? true : null }"><ng-content></ng-content></span>
<i class="fa fa-chevron-up pl-1 ml-1" *ngIf="isAscending" [style.opacity]="isActive ? '1' : '0.4'" [ngClass]="{'text-dark': isActive ? true : null }"></i>
<i class="fa fa-chevron-down pl-1 ml-1" *ngIf="!isAscending" [style.opacity]="isActive ? '1' : '0.4'" [ngClass]="{'text-dark': isActive ? true : null }"></i>

